import {
  ADD_IP,
  SET_COUNT,
  DELETE_ALL_IPS
} from "./types";

// import Service from "../services/ips.service";
import axios from "axios";
const appBaseUrl = (window.location.origin.includes('localhost') ? "https://localhost:8082/ips" : '/ips');
const router = axios.create({
  baseURL : appBaseUrl,
  headers: { "Content-type": "application/json" } 
}); 
 
class IpService {
  create = (data) => router.post("/", data);
  findAll = () => router.get("/");
  findByName = (name) => router.get(`/?name=${name}`);
  deleteAll = () => router.delete('/');
}

export const createIp = (name) => async (dispatch) => {
  try {
    const res = await new IpService().create({ name });

    dispatch({
      type: ADD_IP,
      payload: res.data,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.resolve({ message : "Couldn't create a user"});
  }
};

export const getIps = () => async (dispatch) => {
  try {
    const res = await new  IpService().findAll();

    dispatch({
      type: SET_COUNT,
      payload: res.data,
    });
    return Promise.resolve(res.data);

  } catch (err) {
    return Promise.reject(err.message)
  }
};


export const deleteAllIps = () => async (dispatch) => {
  try {
    const res = await new IpService().deleteAll();

    dispatch({
      type: DELETE_ALL_IPS,
      payload: res.data,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const findIpByName = (name) => async (dispatch) => {
  try {
    const res = await new  IpService().findByName(name);

    return {
      success: true,
      data: res.data
    }
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || err.message
    }
  }
};